

/// <reference path="BankEntry.ts" />

// Generated class BankOpening_ManagedObject

class BankOpening_ManagedObject extends BankEntry
{
}
